import { render, staticRenderFns } from "./KioskAdd.vue?vue&type=template&id=3e65dc14&"
import script from "./KioskAdd.vue?vue&type=script&lang=js&"
export * from "./KioskAdd.vue?vue&type=script&lang=js&"
import style0 from "./KioskAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports